import { Upload } from "lucide-react";
import { Label } from "@/components/ui/label";

export function EvidenceUpload({ files, onFilesChange, testId }) {
  return (
    <div>
      <Label className="text-zinc-500 text-xs uppercase tracking-wide mb-2 block">Evidence (optional)</Label>
      <label className="flex items-center gap-3 border border-dashed border-zinc-300 rounded-sm p-4 cursor-pointer hover:border-zinc-950 transition-colors">
        <Upload className="h-5 w-5 text-zinc-400" />
        <span className="text-sm text-zinc-500">{files.length ? `${files.length} file(s) selected` : "Upload photos, videos, or documents"}</span>
        <input type="file" multiple accept="image/*,video/*,application/pdf" onChange={(e) => onFilesChange(Array.from(e.target.files || []))}
          data-testid={testId} className="hidden" />
      </label>
    </div>
  );
}
